import { ValueOf } from 'type-fest'
import { createReducer } from 'lib/reducerUtils'
import { tourV2RoomSelectionInitialState, TourV2RoomSelectionState } from './tourV2RoomSelectionState'

export enum TourV2RoomSelectionActions {
  EDIT_MODE_TOGGLED = 'EDIT_MODE_TOGGLED',
  MODAL_TOGGLED = 'MODAL_TOGGLED',
  ACTIVE_OCCUPANTS_INDEX_SET = 'ACTIVE_OCCUPANTS_INDEX_SET',
  PURCHASABLE_OPTION_SELECTED = 'PURCHASABLE_OPTION_SELECTED',
  REINITIALISED = 'REINITIALISED'
}

export type TourV2RoomSelectionAction = ValueOf<Utils.FullActionMap<{
  [TourV2RoomSelectionActions.EDIT_MODE_TOGGLED]: {
    isInEditMode: TourV2RoomSelectionState['isInEditMode'],
  }
  [TourV2RoomSelectionActions.MODAL_TOGGLED]: {
    isModalOpen: TourV2RoomSelectionState['isModalOpen'],
  }
  [TourV2RoomSelectionActions.ACTIVE_OCCUPANTS_INDEX_SET]: {
    activeOccupantsIndex: TourV2RoomSelectionState['activeOccupantsIndex'],
  }
  [TourV2RoomSelectionActions.PURCHASABLE_OPTION_SELECTED]: {
    occupants: App.Occupants,
    purchasableOption: Tours.V2OfferPurchasableOption | null
  }
  [TourV2RoomSelectionActions.REINITIALISED]: {}
}>>

const tourV2RoomSelectionStateReducer = createReducer<TourV2RoomSelectionState, TourV2RoomSelectionAction>(
  tourV2RoomSelectionInitialState,
  {
    [TourV2RoomSelectionActions.EDIT_MODE_TOGGLED]: (state, action) => ({
      isInEditMode: action.isInEditMode,
    }),
    [TourV2RoomSelectionActions.MODAL_TOGGLED]: (state, action) => ({
      isModalOpen: action.isModalOpen,
    }),
    [TourV2RoomSelectionActions.ACTIVE_OCCUPANTS_INDEX_SET]: (state, action) => ({
      activeOccupantsIndex: action.activeOccupantsIndex,
    }),
    [TourV2RoomSelectionActions.PURCHASABLE_OPTION_SELECTED]: (state, action) => {
      const selectedPurchasableOptions = new Map(Array.from(state.selectedPurchasableOptions.entries()))

      if (action.purchasableOption === null) {
        selectedPurchasableOptions.delete(action.occupants)
      } else {
        selectedPurchasableOptions.set(action.occupants, action.purchasableOption)
      }

      return { selectedPurchasableOptions }
    },
    [TourV2RoomSelectionActions.REINITIALISED]: () => tourV2RoomSelectionInitialState,
  },
)

export default tourV2RoomSelectionStateReducer
